import React from "react"
import { GridRow, useGridApiContext } from "@mui/x-data-grid-pro"
import { SelectionHint } from "./SelectionHint"
import { useTableContext } from "../../provider"

export const CreateRow = () => {

  const ctx = useTableContext()

  if (ctx.props.CustomRow) {
    if (ctx.props.selectionAllowSelectAll) return CustomRowWithHint
    return ctx.props.CustomRow
  }

  if (ctx.props.selectionAllowSelectAll) return GridRowWithHint
  return GridRow
}

export const GridRowWithHint = (props: any) => {

  if (props.index === 0) return (
    <>
      <SelectionHint index={props.index} />
      <GridRow {...props} />
    </>
  )

  return (
    <GridRow {...props} />
  )
}

export const CustomRowWithHint = (props: any) => {
  const ctx = useTableContext()

  const { CustomRow } = ctx.props

  if (!CustomRow) return null

  if (props.index === 0) return (
    <>
      <SelectionHint index={props.index} />
      {CustomRow(props)}
    </>
  )

  return (
    CustomRow(props)
  )
}
